<template>
  <section>
    <h4>Manager Pools</h4>
    <LoadingSpinner v-if="loading || loadingTabs" />
    <div class="row my-1 px-2" v-if="!loading && !loadingTabs">
      <div class="px-3 pb-3 d-inline">
        <Tabs
          :tabs="tabs"
          @change="changeTab($event)"
          :tabSelected="tabSelected"
        />
      </div>

      <div class="col-12 px-1">
        <div class="row">
          <div class="col-md-3">
            <date-picker
              id="startDatePicker"
              class=""
              v-model="range.startDate"
              :config="datePickerConfig"
              placeholder="Start Date"
            ></date-picker>
          </div>

          <div class="col-md-3">
            <date-picker
              id="endDatePicker"
              class=""
              v-model="range.endDate"
              :config="datePickerConfigEndDate"
              placeholder="End Date"
            ></date-picker>
          </div>

          <div class="col-9 col-md-2">
            <button
              class="btn btn-success"
              @click="getData()"
              style="width: 100%"
              :disabled="loading"
            >
              <i class="icon-calendar-check-o mr-2"></i>
              <small>
                {{ $t("lang.button.filter") }}
              </small>
            </button>
          </div>
        </div>
      </div>

      <div class="col=12 w-100 my-1">
        <div class="row mt-3 mb-3">
          <div class="col-12">
            <span class="ml-2">{{ $t("lang.label.orderby") }}:</span>

            <span class="mx-2">
              <select
                v-model="orderBy"
                @change="updateOrder"
                class="form-control"
              >
                <option value="verified_tasks">Verified tasks</option>
                <option value="meetings_booked">Meetings booked</option>
                <option value="meetings_rate">Meetings rate</option>
                <option value="cold_meeting_rate">Cold Meetings rate</option>
              </select>
            </span>

            <span class="mx-2">
              <select
                v-model="orderDirection"
                @change="updateOrder"
                class="form-control"
              >
                <option value="asc">Asc</option>
                <option value="desc">Desc</option>
              </select>
            </span>
          </div>
        </div>

        <div
          class="mx-0 px-0 table-responsive table-sticky table-sticky-1col table-sticky-3col"
          v-if="!loading"
        >
          <Table
            v-if="users.length > 0"
            class="mx-2 w-100"
            :headers="headers"
            :cols="cols"
            :data="users"
            :checkbox="false"
            :notselect="true"
            :model="model"
            :fieldsLoading="fieldsLoading"
            :key="key"
            @goToUser="goToUser"
          >
          </Table>
          <div class="row" v-else>
            <div class="col-12 col-md-10 offset-md-1 text-center">
              <div class="alert alert-primary mx-5 my-2 px-2 py-4">
                <h6>
                  <i class="fas fa-exclamation-triangle mr-2"></i>
                  No bookers to show
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex";
import { bookersService } from "@/_services";
import Table from "@/components/Common/Table.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import Tabs from "@/components/Common/Tabs.vue";
import moment from "moment";
export default {
  components: {
    LoadingSpinner,
    Tabs,
    Table,
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.authentication.user,
      isMenuCollapse: (state) => state.sidebar.isNavOpen,
      filtersSystem: (state) => state.campaigns.filtersSystem,
    }),
  },
  data() {
    return {
      loadingTabs: false,
      loading: false,
      tabSelected: 1,
      orderBy: "cold_meeting_rate",
      orderDirection: "desc",
      tabs: {},
      users: [],
      fieldsLoading: true,
      key: 1,
      model: {
        imported: false,
        refreshlist: false,
        selectfirst: false,
        cantPerPage: 25,
        currentPage: 1,
      },
      datePickerConfig: {
        format: "YYYY-MM-DD",
        useCurrent: false,
        maxDate: moment().endOf("day"),
      },
      datePickerConfigEndDate: {
        format: "YYYY-MM-DD",
        useCurrent: false,
        maxDate: moment().endOf("day"),
      },
      range: {
        startDate: moment().startOf("month").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      filterMonth: moment().format("YYYY-MMM"),
      cols: [
        [
          {
            value: "rk_number",
          },
        ],
        [
          {
            value: "avatar",
            type: "image",
            width: "25px",
          },
        ],
        [
          {
            value_label: "name",
            value_emit: "id",
            class: "text-primary",
            type: "emit",
            emit: "goToUser",
          },
        ],
        [
          {
            value: "id",
            type: "imageSetClients",
          },
        ],
        [
          {
            value: "warning_icon",
            show_text: "false",
            icons: [
              {
                icon_if_value: "1",
                icon_true: "icon-warning text-warning",
              },
              {
                icon_if_value: "2",
                icon_true: "icon-warning text-danger icon-small",
              },
              {
                icon_if_value: "3",
                icon_true: "icon-automobile text-warning icon-small",
              },
              {
                icon_if_value: "4",
                icon_true: "icon-automobile text-danger icon-small",
              },
            ],
          },
        ],
        [
          {
            value: "user_bdr_status_id",
            value2: "days_since_status_change",
            value_label: "bdr_status",
            type: "itemBadge",
            class: "badge",
            colors: [
              {
                id: "1",
                label: "Screening",
                bgColor: "gray",
                textColor: "#FFFFFF",
              },
              {
                id: "2",
                label: "Onboarding",
                bgColor: "orange",
                textColor: "#FFFFFF",
              },
              {
                id: "3",
                label: "Validated",
                bgColor: "green",
                textColor: "#FFFFFF",
              },
              {
                id: "4",
                label: "Level 1",
                bgColor: "green",
                textColor: "#FFFFFF",
              },
              {
                id: "5",
                label: "Booker Level 2",
                bgColor: "#FF8C00",
                textColor: "#FFFFFF",
              },
              {
                id: "6",
                label: "Booker Manager",
                bgColor: "#4B0082",
                textColor: "#FFFFFF",
              },
              {
                id: "7",
                label: "Stopped",
                bgColor: "#B22222",
                textColor: "#FFFFFF",
              },
              {
                id: "8",
                label: "Rejected",
                bgColor: "red",
                textColor: "#FFFFFF",
              },
              {
                id: "9",
                label: "Test",
                bgColor: "black",
                textColor: "#FFFFFF",
              },
              {
                id: "10",
                label: "Booker France",
                bgColor: "blue",
                textColor: "#FFFFFF",
              },
              {
                id: "11",
                label: "Booker Hivy",
                bgColor: "yellow",
                textColor: "black",
              },
              {
                id: "14",
                label: "Props. Closing",
                bgColor: "#C6F505",
                textColor: "black",
              },
              {
                id: "15",
                label: "Booker Level 3",
                bgColor: "#279CF5",
                textColor: "#FFFFFF",
              },
              {
                id: "16",
                label: "Booker Level 4",
                bgColor: "#F5AD27",
                textColor: "#FFFFFF",
              },
              {
                id: "empty",
                label: "",
                bgColor: "white",
                textColor: "#FFFFFF",
              },
            ],
          },
        ],
        [
          {
            value: "hours_worked",
            show_text: "false",
            icons: [
              {
                icon_if_value: "PART TIME",
                icon_true: "icon-battery-half text-warning icon-small",
                tooltip_true: "PART TIME",
              },
            ],
          },
        ],
        [
          {
            value: "verified_tasks",
          },
        ],
        [
          {
            value: "pick_ups",
            format: "percentage",
            type: "itemBadgeConditional",
            min: "min_r1",
          },
        ],
        [
          {
            value: "completion",
            format: "percentage",
          },
        ],
        [
          {
            value: "meetings_booked",
            value2: "hasBonusLevel2",
            format: "bonus",
            type: "itemBadge"
          },
          {
            tooltip_icon: "icon-question-circle",
            condition: "has_appointment",
            value: "meetings_booked_tooltip",
            type: "tooltipNote"
          },
        ],
        [
          {
            value: "meetings_rate",
            format: "percentage",
          },
        ],
        [
          {
            value: "cold_meeting_rate",
            format: "percentage",
          },
        ],
        // [
        //   {
        //     value: "meetings_per_day",
        //   },
        // ],
        [
          {
            value: "consistency",
            format: "percentage",
            link: "linkConsistency",
            type: "link",
          },
        ],
        [
          {
            value: "adapted_fixed_salary",
            format: "money",
            simbol: "€",
            icon: "icon_sent-mail2.png",
            tooltip_value: "fixed_salary_tooltip",
            tooltip_icon: "fa-question-circle",
          },
        ],
        [
          {
            value: "total_commission_meeting",
            link: "linkComission",
            type: "link",
          },
        ],
        [
          {
            value: "lost_meetings_prc",
            format: "percentage",
            type: "itemBadgeConditional",
            max: "max_r1",
          },
        ],
        [
          {
            value: "bonus_commission",
            type: "itemBadge",
            class: "badge badge-pill text-small",
            colors: [
              {
                id: "1",
                label: "",
                bgColor: "transparent",
                textColor: "#000000",
              },
              {
                id: "2",
                label: "Com X2",
                bgColor: "#9ADD08",
                textColor: "#000000",
                fontSize: "10px",
              },
            ],
          },
          {
            value: "bonus_meeting",
            type: "itemBadge",
            class: "badge badge-pill text-small",
            colors: [
              {
                id: "1",
                label: "",
                bgColor: "transparent",
                textColor: "#000000",
              },
              {
                id: "2",
                label: "Com X2",
                bgColor: "#512da8",
                textColor: "#000000",
                fontSize: "10px",
              },
            ],
          },
        ],
        [
          {
            value: "booker_salary",
            format: "money",
            simbol: "€",
          },
        ],
        [
          {
            value: "booker_revenue_generated",
            format: "money",
            simbol: "€",
          },
        ],
        [
          {
            value: "booker_gross_margin",
            format: "percentage",
          },
        ],
      ],
      headers: [
        {
          label: "RK",
          percentage: "0.1%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 1,
        },
        {
          label: "Photo",
          percentage: "0.1%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 1,
        },
        {
          label: "Name",
          percentage: "10.5%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 1,
        },
        {
          label: "Clients",
          percentage: "22.5%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager"],
          id: 2,
        },
        {
          label: "Warning",
          percentage: "2.5%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager"],
          id: 1,
        },
        {
          label: "Status",
          percentage: "12.5%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 1,
        },
        {
          label: this.$t("lang.column.header_booker_modality"),
          percentage: "12.5%",
          class: "overflowhide",
          tooltip_value: this.$t("lang.column.header_content_modality"),
          tooltip_icon: "fa-question-circle",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 1,
        },
        {
          label: this.$t("lang.column.header_booker_ver_tks"),
          percentage: "10.5%",
          class: "overflowhide",
          tooltip_value: this.$t("lang.column.header_content_ver_tks"),
          tooltip_icon: "fa-question-circle",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 1,
        },
        {
          label: this.$t("lang.column.header_booker_pick_ups"),
          percentage: "10.5%",
          class: "overflowhide",
          tooltip_value: this.$t("lang.column.header_content_pick_ups"),
          tooltip_icon: "fa-question-circle",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 1,
        },
        {
          label: this.$t("lang.column.header_booker_completion"),
          percentage: "10.5%",
          class: "overflowhide",
          tooltip_value: this.$t("lang.column.header_content_completion"),
          tooltip_icon: "fa-question-circle",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 1,
        },
        {
          label: this.$t("lang.column.header_booker_meet_bk"),
          percentage: "10.5%",
          class: "overflowhide",
          tooltip_value: this.$t("lang.column.header_content_meet_bk"),
          tooltip_icon: "fa-question-circle",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 1,
        },
        {
          label: this.$t("lang.column.header_booker_meet_rt"),
          percentage: "12.5%",
          class: "overflowhide",
          tooltip_value: this.$t("lang.column.header_content_meet_rt"),
          tooltip_icon: "fa-question-circle",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 2,
        },
        {
          label: this.$t("lang.column.header_booker_cold_mt"),
          percentage: "12.5%",
          class: "overflowhide",
          tooltip_value: this.$t("lang.column.header_content_cold_mt"),
          tooltip_icon: "fa-question-circle",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 2,
        },
        {
          label: this.$t("lang.column.header_booker_meet_day"),
          percentage: "12.5%",
          class: "overflowhide",
          tooltip_value: this.$t("lang.column.header_content_meet_day"),
          tooltip_icon: "fa-question-circle",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 2,
        },
        {
          label: this.$t("lang.column.header_booker_consistency"),
          percentage: "12.5%",
          class: "overflowhide",
          tooltip_value: this.$t("lang.column.header_content_consistency"),
          tooltip_icon: "fa-question-circle",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 2,
        },
        {
          label: this.$t("lang.column.header_booker_fix_sal"),
          percentage: "12.5%",
          class: "overflowhide",
          tooltip_value: this.$t("lang.column.header_content_fix_sal"),
          tooltip_icon: "fa-question-circle",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 2,
        },
        {
          label: this.$t("lang.column.header_booker_commission"),
          percentage: "12.5%",
          class: "overflowhide",
          tooltip_value: this.$t("lang.column.header_content_commission"),
          tooltip_icon: "fa-question-circle",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 2,
        },
        {
          label: this.$t("lang.column.header_booker_lost_meet"),
          percentage: "12.5%",
          class: "overflowhide",
          tooltip_value: this.$t("lang.column.header_content_lost_meet"),
          tooltip_icon: "fa-question-circle",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 2,
        },
        {
          label: "Bonus",
          percentage: "12.5%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 2,
        },
        {
          label: this.$t("lang.column.header_booker_bk_sal"),
          percentage: "12.5%",
          class: "overflowhide",
          tooltip_value: this.$t("lang.column.header_content_bk_sal"),
          tooltip_icon: "fa-question-circle",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 2,
        },
        {
          label: this.$t("lang.column.header_booker_revenue"),
          percentage: "12.5%",
          class: "overflowhide",
          tooltip_value: this.$t("lang.column.header_content_revenue"),
          tooltip_icon: "fa-question-circle",
          permission: ["AgencyBilling", "isBookerManager"],
          id: 2,
        },
        {
          label: this.$t("lang.column.header_booker_gross"),
          percentage: "12.5%",
          class: "overflowhide",
          tooltip_value: this.$t("lang.column.header_content_gross"),
          tooltip_icon: "fa-question-circle",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 2,
        },
      ],
    };
  },

  created() {
    this.getBookerManager();
  },
  mounted() {},
  methods: {
    changeTab(id) {
      if (this.tabSelected === id) return; //evitamos cargar info del mismo tab
      this.tabSelected = id;
      this.key++;
      this.getData();
    },
    updateOrder() {
      let rowTotals = [];
      if (this.users.length && this.users[this.users.length - 1].totalRow) {
        rowTotals = this.users.filter((el) => el.totalRow);

        this.users = this.users.filter((el) => !el.totalRow);
      } else {
        rowTotals = null;
      }

      this.users = this.users.slice().sort((a, b) => {
        // Obtener valores a comparar
        let propA = a[this.orderBy];
        let propB = b[this.orderBy];

        // Manejar valores nulos o no definidos
        if (propA === null || propA === undefined) propA = 0;
        if (propB === null || propB === undefined) propB = 0;

        // Convertir cadenas numéricas a números
        if (!isNaN(propA)) propA = Number(propA);
        if (!isNaN(propB)) propB = Number(propB);

        let result;

        // Comparar como números o como texto
        if (typeof propA === "number" && typeof propB === "number") {
          result = propA - propB; // Comparación numérica
        } else {
          result = propA.toString().localeCompare(propB.toString()); // Comparación textual
        }

        // Ajustar para orden descendente
        if (this.orderDirection === "desc") {
          result *= -1;
        }

        return result;
      });

      // Volver a agregar la fila de totales si existía
      if (rowTotals) {
        this.users.push(...rowTotals);
      }
    },
    addLinksToUsers() {
      this.users = this.users.map((user) => ({
        ...user,
        linkComission: this.linkComission,
        linkConsistency: this.linkConsistency,
      }));
    },
    getBookerManager() {
      this.loadingTabs = true;
      if (this.currentUser.role_id != 2) {
        bookersService
          .getBookerManager()
          .then((response) => {
            if (response.status === 200 && response.result.list) {
              this.tabs = {};
              response.result.list.forEach((item) => {
                this.tabs[item.id] = {
                  id: Number(item.id),
                  name: item.name,
                };
              });

              const tabId = Object.keys(this.tabs)[0];
              this.tabSelected = Number(tabId);

              this.getData("updateOrder");
            }
            this.loadingTabs = false;
          })
          .catch((err) => console.log(err));
      } else {
        this.tabSelected = Number(this.currentUser.booker.user_id);
        this.loadingTabs = false;
        this.getData("updateOrder");
      }
    },
    getData(updateOrder = null) {
      this.loading = true;
      const { startDate, endDate } = this.range;
      let type_role;
      type_role = this.currentUser.role_id == 1 ? 'ad' : this.currentUser.role_id == 2 ? 'bk' : 'ot';
      const filters = {
        start_date: startDate,
        end_date: endDate,
        booker_manager_id: this.tabSelected,
        role: type_role,
      };
      bookersService.getBookerRanking(filters).then((response) => {
        if (response !== undefined) {
          //Calculos para resultados, para la ultima final
          if (response.result.length > 0) {
            const result = response.result;

            result.forEach((element) => {
              element.min_r1 = 5;
              element.max_r1 = 50;
              element.hasBonusLevel2 = false;

              if(element.bonus_meeting == 2) element.hasBonusLevel2 = true;
              
              if(element.meetings_booked < 1){
                element.has_appointment = false;
                element.meetings_booked_tooltip = this.$t("lang.label.no_meetings_booked");
              }else{
                element.has_appointment = true;
                element.meetings_booked_tooltip = '';
              }

              if(element.has_avatar == 1){
                let base64 = '';
                base64 = btoa(`usr-${element.id}`);
                element.avatar = process.env.VUE_APP_ROOT_API + '/redirect/image/' + base64;
              }else{
                element.avatar = require('@/assets/images/emptyperson.png');
              }

              if (element.consistency < 60) {
                element.salary_degrasivity = this.$t(
                  "lang.bdr.salarydegrasivity50prc"
                );
              } else if (element.consistency < 80) {
                element.salary_degrasivity = this.$t(
                  "lang.bdr.salarydegrasivity70prc"
                );
              }

              if (element.adapted_fixed_salary) {
                element.fixed_salary_tooltip = this.$t("lang.bdr.fixed_salary");
              } else {
                element.fixed_salary_tooltip = "";
              }

              if (["4", "5"].includes(element.user_bdr_status_id)) {
                if (
                  element.verified_tasks >= 300 &&
                  element.verified_tasks < 600 &&
                  element.cold_meeting_rate == 0
                ) {
                  element.warning_icon = 1;
                } else if (
                  element.verified_tasks >= 600 &&
                  element.cold_meeting_rate == 0
                ) {
                  element.warning_icon = 2;
                }
                const today = new Date();
                const todayDay = today.getDate();
                if (
                  element.consistency < 15 &&
                  element.cold_meeting_rate == 0
                ) {
                  if (
                    (element.user_bdr_status_id == 4 &&
                      element.days_since_status_change >= 5 &&
                      element.days_since_status_change < 15) ||
                    ((element.days_since_status_change >= 30 ||
                      element.user_bdr_status_id == 5) &&
                      todayDay >= 5 &&
                      todayDay < 15)
                  ) {
                    element.warning_icon = 3;
                  } else if (
                    (element.user_bdr_status_id == 4 &&
                      element.days_since_status_change >= 15 &&
                      element.days_since_status_change < 30) ||
                    ((element.days_since_status_change >= 30 ||
                      element.user_bdr_status_id == 5) &&
                      todayDay >= 15)
                  ) {
                    element.warning_icon = 4;
                  }
                }
              }
            });

            const verified_tasks_total = result.reduce(
              (sum, item) => sum + Number(item.verified_tasks),
              0
            );
            const treated_opportunities_total = result.reduce(
              (sum, item) => sum + Number(item.treated_opportunities),
              0
            );
            const meetings_booked_total = result.reduce(
              (sum, item) => sum + Number(item.meetings_booked),
              0
            );
            const simple_meeting_rate =
              result
                .filter((el) => el.meetings_rate)
                .reduce((sum, item) => sum + Number(item.meetings_rate), 0) /
              result.filter((el) => el.meetings_rate).length;
            const simple_cold_meeting_rate =
              result
                .filter((el) => el.cold_meeting_rate)
                .reduce(
                  (sum, item) => sum + Number(item.cold_meeting_rate),
                  0
                ) / result.filter((el) => el.cold_meeting_rate).length;
            // const simple_meetings_per_day =
            //   result
            //     .filter((el) => el.meetings_per_day)
            //     .reduce((sum, item) => sum + Number(item.meetings_per_day), 0) /
            //   result.filter((el) => el.meetings_per_day).length;

            const booker_salary_total = result.reduce(
              (sum, item) => sum + Number(item.booker_salary),
              0
            );
            const booker_revenue_generated_total = result.reduce(
              (sum, item) => sum + Number(item.booker_revenue_generated),
              0
            );
            const simple_booker_gross_margin =
              ((booker_revenue_generated_total - booker_salary_total) /
                booker_revenue_generated_total) *
              100;
            const simple_consistency =
              result
                .filter((el) => el.consistency)
                .reduce((sum, item) => sum + Number(item.consistency), 0) /
              result.filter((el) => el.consistency).length;
            const fixed_salary_total = result.reduce(
              (sum, item) => sum + Number(item.adapted_fixed_salary),
              0
            );
            const total_commission_meeting_total = result.reduce(
              (sum, item) => sum + Number(item.total_commission_meeting),
              0
            );

            const filtered = result.map((el) => ({
              ...el,
              lost_meetings_prc:
                el.lost_meetings_prc != null ? Number(el.lost_meetings_prc) : 0,
            }));

            const count = filtered.length;

            const total_meetings_lost_rate =
              count > 0
                ? filtered.reduce(
                    (sum, item) => sum + item.lost_meetings_prc,
                    0
                  ) / count
                : 0;

            response.result = response.result.map((item, i) => {
              const rk_number = i + 1;
              return {
                ...item,
                bookerExpert: item.user_bdr_status_id,
                rk_number: rk_number,
              };
            });

            response.result = [
              ...response.result,
              {
                totalRow: true,
                avatar: "",
                email: "",
                id: "6123456",
                name: "",
                verified_tasks: verified_tasks_total,
                treated_opportunities: treated_opportunities_total,
                meetings_booked: meetings_booked_total,
                meetings_rate: simple_meeting_rate.toFixed(2),
                cold_meeting_rate: simple_cold_meeting_rate.toFixed(2),
                //meetings_per_day: simple_meetings_per_day.toFixed(2),
                booker_salary: booker_salary_total.toFixed(2),
                booker_revenue_generated:
                  booker_revenue_generated_total.toFixed(2),
                booker_gross_margin: simple_booker_gross_margin.toFixed(2),
                consistency: simple_consistency.toFixed(2),
                adapted_fixed_salary: fixed_salary_total.toFixed(2),
                total_commission_meeting: total_commission_meeting_total,
                lost_meetings_prc: total_meetings_lost_rate.toFixed(2),
                bdr_status: "empty",
                rk_number: "",
              },
            ];
            this.users = response.result;
            this.addLinksToUsers();
            if (updateOrder) {
              this.updateOrder();
            }
          } else {
            this.users = [];
          }
        }
        this.loading = false;
      });
    },
    isBookerManager() {
      return this.currentUser.role_id == 9;
    },
    goToUser(user_id) {
      if (this.currentUser.role_id == 1) {
        window.open("/users/" + user_id, "_blank");
      }
    },
  },
};
</script>

<style></style>
